import { Link } from "react-router-dom";
import { HelpCircle, Sparkles } from "lucide-react";

export default function MobileTopBar() {
  return (
    <header data-testid="mobile-topbar" className="lg:hidden sticky top-0 z-40 bg-[#0b0a10]/85 backdrop-blur-xl border-b border-white/5 -mx-4 sm:-mx-6 px-4 sm:px-6 mb-3 pt-[max(0.5rem,env(safe-area-inset-top))] pb-2.5 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2.5" data-testid="mobile-logo">
        <img src="/logo.png" alt="The Trading Dock" className="w-8 h-8 rounded-lg ring-1 ring-white/10"/>
        <div className="leading-tight">
          <div className="text-[12px] font-bold tracking-tight text-white">THE TRADING DOCK<sup className="text-[7px] opacity-60">®</sup></div>
          <div className="text-[8px] uppercase tracking-[0.18em] text-slate-500 font-semibold">finance</div>
        </div>
      </Link>
      <div className="flex items-center gap-1">
        <Link to="/ayuda" data-testid="mobile-help" aria-label="Ayuda"
          className="p-2 rounded-xl bg-white/[0.04] border border-white/5 text-slate-400 hover:text-white">
          <HelpCircle className="w-4 h-4"/>
        </Link>
        <Link to="/perfil" data-testid="mobile-pro"
          className="hidden xs:flex items-center gap-1 px-2.5 py-1.5 rounded-xl bg-gradient-to-r from-violet-500/20 to-fuchsia-500/20 border border-violet-500/30 text-violet-200 text-[11px] font-semibold">
          <Sparkles className="w-3 h-3"/> Pro
        </Link>
      </div>
    </header>
  );
}
